import { Pipe, PipeTransform } from '@angular/core';
import { INDRAIbeAdminService } from './ibeadmin.indra.service';
import { tap, map } from 'rxjs/operators';
import { INDRATranslationToggleService } from "@ibe.components/translation-toggle/translation-toggle.service";

@Pipe({
	name: 'ibeadmin'
})
export class INDRAIbeAdminPipe implements PipeTransform {

	constructor(private ibeAdminService: INDRAIbeAdminService, private translationToggle: INDRATranslationToggleService) { }

	transform(value: string, callingMethod: string, placeholder: boolean = true): any {
		let loaderKey = value;
		if (value) {
			if (callingMethod) {
				if (callingMethod == 'sync') {
					return this.ibeAdminService.getTranslationValue(value);
				}
				else {
					if(this.translationToggle.getValue()) {
						return this.ibeAdminService.getTranslationValueAsync(value, true);
					} else {
						return this.ibeAdminService.getTranslationValueAsync(value, true).pipe(
							tap ((data) => {
								if (data === value) {
									this.ibeAdminService.setLoadingState(loaderKey, true)
								} else {
									this.ibeAdminService.setLoadingState(loaderKey, false)
								}
							}),
							map ((data) => {
								if (data === value && placeholder) {
									return 'Loading...'
								}

								return data;
							})
						);
					}
				}

			} else
				if(this.translationToggle.getValue()) {
					return this.ibeAdminService.getTranslationValueAsync(value, true)
				} else {
					return this.ibeAdminService.getTranslationValueAsync(value, true).pipe(
						tap ((data) => {
							if (data === value) {
								this.ibeAdminService.setLoadingState(loaderKey, true)
							} else {
								this.ibeAdminService.setLoadingState(loaderKey, false)
							}
						}),
						map ((data) => {
							if (data === value && placeholder) {
								return 'Loading...'
							}

							return data;
						})
					);
				}
		}
	}
}
